export const CSS = {
	container: 'c-BearingInput',
	label: 'c-BearingInput__label',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		'align-items': 'center',
	},
};
